<template>
  <div
    class="modal fade"
    id="sys_device_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            ×
          </button>
          <h4 class="modal-title" id="myModalLabel">
            智能电表&nbsp;<span class="ammeterMessage"
              >（ 基站：{{ msgAmmeterinfo.stst_commname }} 电表编号：{{
                msgAmmeterinfo.ammeter_numbering
              }} ）</span
            >
          </h4>
        </div>
        <!-- modal-body-->
        <div class="modal-body">
          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#tab-1" @click="tabSwitch('electric_quantity')"
                >电量</a
              >
            </li>
            <li class>
              <a data-toggle="tab" href="#tab-1" @click="tabSwitch('active_power')"
                >功率</a
              >
            </li>
            <li class>
              <a data-toggle="tab" href="#tab-1" @click="tabSwitch('power_factor')"
                >功率因数</a
              >
            </li>
            <li class v-show="idType">
              <button
                class="btn btn-warning"
                id="close"
                @click="close"
                style="margin: 0 10px 0 10px"
              >
                拉闸
              </button>
            </li>
            <li class v-show="idType">
              <button
                class="btn btn-info"
                id="open"
                @click="open"
                style="margin-right: 10px"
              >
                合闸
              </button>
            </li>
            <li class>
              <button
                class="btn btn-info"
                id="uploadNumber"
                @click="uploadNumber"
                style="margin-right: 10px"
              >
                远程抄表
              </button>
            </li>
            <li>
              <a class="electricQuantity"></a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="tab-1" class="tab-pane active">
              <div class="form-group clearfix" style="margin: 15px 0">
                <label class="col-sm-1 control-label">开始时间：</label>
                <div class="col-sm-2">
                  <input
                    name="start"
                    id="startTime"
                    type="text"
                    class="form-control"
                    @click="datePicker('startTime')"
                  />
                </div>
                <label class="col-sm-1 control-label">结束时间：</label>
                <div class="col-sm-2">
                  <input
                    name="end"
                    id="endTime"
                    type="text"
                    class="form-control"
                    @click="datePicker('endTime')"
                  />
                </div>
                <label class="col-sm-2 control-label">采样时间间隔：</label>
                <div class="interval col-sm-4">
                  <button
                    class="btn"
                    :class="{ 'btn-info': interval == '1' }"
                    @click="intervalfn('1')"
                  >
                    实际采样
                  </button>
                  <button
                    class="btn"
                    :class="{ 'btn-info': interval == '60' }"
                    @click="intervalfn('60')"
                  >
                    小时
                  </button>
                  <button
                    class="btn"
                    :class="{ 'btn-info': interval == '1440' }"
                    @click="intervalfn('1440')"
                  >
                    天
                  </button>
                </div>
              </div>
              <div id="main" style="width: 900px; height: 540px; margin: 0 auto"></div>
            </div>
            <div id="tab-2" class="tab-pane"></div>
          </div>
        </div>
        <!-- modal-footer -->
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
          <!-- <button type="button" data-dismiss="modal" class="btn btn-primary">ËÑË÷</button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var option = {};
var myChart = null;
export default {
  data() {
    return {
      startTime: Date.parse(new Date()) / 1000 - 2592000, //开始时间初始化
      endTime: Date.parse(new Date()) / 1000, //  结束时间初始化
      interval: 1,
      paramType: "electric_quantity", // 功率
      myChartData: [],
      idType: true,
    };
  },
  props: ["msgAmmeterid", "msgAmmeterinfo"], // 电表id
  mounted: function () {
    var self = this;
    // 运营商身份不显示拉合闸
    var companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    if (companyInfo.type == "运营商") {
      self.idType = false;
    } else {
      self.idType = true;
    }

    myChart = self.echarts.init(document.getElementById("main")); // 基于准备好的dom，初始化echarts实例
    // var myChartData = []; // 传入chart中的数据
    option = {
      title: {
        text: "",
      },
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          params = params[0];
          var date = new Date(params.name);
          return (
            date.getFullYear() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getDate() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            "  " +
            params.value[1]
          );
        },
        axisPointer: {
          animation: false,
        },
      },
      toolbox: {
        // feature 各工具配置项: dataZoom 数据区域缩放;restore 配置项还原;saveAsImage下载为图片;magicType动态类型切换
        feature: {
          // dataZoom: {
          //     yAxisIndex: 'true',   // y轴不缩放，Index默认为0
          //     xAxisIndex: 'false'  // x轴不缩放，Index默认为0
          // },
          // restore: {},
          saveAsImage: {},
        },
      },
      dataZoom: [
        {
          // 内置于坐标系中，使用户可以在坐标系上通过鼠标拖拽、鼠标滚轮、手指滑动（触屏上）来缩放或漫游坐标系
          type: "inside",
          start: 0, // 起始的百分比
          end: 100, // 结束的百分比
          // startValue:"2019/1/11",  // 起始时间  (和其实结束的百分比不可共存)
          // endValue:'2021/10/6',  // 结束时间
        },
        {
          start: 0,
          end: 10, // handleIcon 手柄的 icon 形状，支持路径字符串
          handleIcon:
            "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
          handleSize: "80%", //  控制手柄的尺寸，可以是像素大小，也可以是相对于 dataZoom 组件宽度的百分比，默认跟 dataZoom 宽度相同。
          handleStyle: {
            color: "pink",
            shadowBlur: 3, // shadowBlur图片阴影模糊值，shadowColor阴影的颜色
            shadowColor: "red",
            shadowOffsetX: 2,
            shadowOffsetY: 2,
          },
        },
      ],
      xAxis: {
        type: "time",
        splitLine: {
          show: false,
        },
        boundaryGap: false,
        splitNumber: 5,
      },
      yAxis: {
        type: "value",
        boundaryGap: [0, "100%"],
        splitLine: {
          show: true,
        },
      },
      series: [
        {
          name: "模拟数据",
          type: "line",
          showSymbol: false,
          hoverAnimation: true,
          data: self.myChartData,
        },
      ],
    };

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  },
  methods: {
    intfunc: function () {
      var self = this;
      console.log(self.msgAmmeterid);
      console.log("msgAmmeterInfo", self.msgAmmeterinfo);

      // self.ammeter_query();
      self.getElectricTotal();
      self.tabSwitch("electric_quantity");
    },
    tabSwitch: function (param) {
      var self = this;
      self.paramType = param;
      self.ammeter_query();
      //option.series[0].data = self.myChartData;
      //myChart.setOption(option, true);
    },
    // 父组件调用的初始化方法
    ammeter_query: function () {
      var self = this;
      myChart.clear(); //先销毁数据
      self.myChartData = [];
      var postData = {
        type: self.paramType, // active_power 功率 electric_quantity 电量
        start: self.startTime,
        end: self.endTime,
        interval: self.interval,
      };

      self.global.axiosPost(
        self,
        "ammeter/" + self.msgAmmeterid + "/show/",
        postData,
        function (res) {
          if (res.length === 0) {
            option.series[0].data = self.myChartData;
            myChart.setOption(option, true);
            alert("数据为空");
            return;
          }
          var response = res[0].values;
          if (response == null) {
            alert("数据为空");
            return;
          }
          for (var i = 0; i < response.length; i++) {
            var dataObj = {};
            dataObj.name = new Date(parseInt(response[i][0]) * 1000).toString();
            dataObj.value = [response[i][0] * 1000, response[i][1]];
            self.myChartData.push(dataObj);
          }
          option.series[0].data = self.myChartData;
          myChart.setOption(option, true);
        },
        function () {
          alert("操作失败");
        }
      );
    },
    close: function () {
      var self = this;
      var r = confirm("您确定要拉闸该电表吗?\n响应时间较长,请耐心等候"); // 询问框里的文字描述
      if (r == true) {
        self.global.axiosPost(
          self,
          "ammeter/" + self.msgAmmeterid + "/close/",
          {},
          function (d) {
            if (d.commandId) {
              alert("拉闸成功!");
            } else {
              alert("操作失败,请稍后重试!");
            }
          },
          function (res) {
            alert("操作失败:没有权限");
          }
        );
      } else {
        console.log("取消");
      }
    },
    open: function () {
      var self = this;
      var r = confirm("您确定要合闸该电表吗?\n响应时间较长,请耐心等候"); // 询问框里的文字描述
      if (r == true) {
        self.global.axiosPost(
          self,
          "ammeter/" + self.msgAmmeterid + "/open/",
          {},
          function (d) {
            if (d.commandId) {
              alert("合闸成功!");
            } else {
              alert("操作失败,请稍后重试!");
            }
          },
          function (res) {
            alert("操作失败:没有权限");
          }
        );
      } else {
        console.log("取消");
      }
    },
    uploadNumber: function () {
      var self = this;
      self.global.axiosPost(
        self,
        "ammeter/" + self.msgAmmeterid + "/read/",
        {},
        function (d) {
          if (d.commandId) {
            alert("上传成功!");
          } else {
            alert("操作失败,请稍后重试!");
          }
        },
        function (e) {
          alert("操作失败");
        }
      );
    },
    proxy: function (url, param, callback) {
      var self = this;
      self.global.axiosPost(
        self,
        url,
        param,
        function (d) {
          callback(d);
        },
        function () {
          alert("操作失败");
        }
      );
    },
    //电量最新读数
    getElectricTotal: function () {
      console.log("getElectricTotal");
      var self = this;
      self.global.axiosPost(
        self,
        "ammeter/" + self.msgAmmeterid + "/show/",
        { type: "electric_total" },
        function (d) {
          console.log(d);
          $(".electricQuantity").html(
            "最新电量: " +
              d.value +
              "&nbsp;&nbsp;(" +
              new Date(d.timestamp).toLocaleString() +
              ")"
          );
        },
        function () {
          alert("操作失败");
        }
      );
    },
    datePicker: function (elementId) {
      let self = this;
      WdatePicker({
        el: elementId,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          self[elementId] = self.global.timeToStamp(value);
          self.tabSwitch(self.paramType);
        },
        oncleared: function () {
          self[elementId] = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    intervalfn: function (param) {
      var self = this;
      ("btn-info");
      self.interval = param;
      self.ammeter_query();
      myChart.clear();
      option.series[0].data = self.myChartData;
      myChart.setOption(option, true);
    },
  },
};
</script>
<style scoped>
.ammeterMessage {
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/ammeter/ammetersmart.vue